import { render, staticRenderFns } from "./InvestmentPage.vue?vue&type=template&id=7c772cc3"
import script from "./InvestmentPage.vue?vue&type=script&lang=ts"
export * from "./InvestmentPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports